export default{
  accountInfo: (state) => state.accountInfo
}



// WEBPACK FOOTER //
// ./src/components/account/store/getters.js